const mensagens = {
    JUMBOTRON_AZUL_SUPERIOR: {
        MENSAGEM_BOAS_VINDAS: "Olá, ",
        MENSAGEM_USUARIO_GENERICO: "desconhecido!"
    },
    MODAL_RECONHECIMENTO_FACIAL:{
        TITULO: "Verificação"
    },
    MENU_LATERAL: {
        VERIFICADO_EM: "Verificado em ",
        BENEFICIARIO_ATIVO_EM: "Beneficiário ativo em ",
        BENEFICIARIO_ISENTO_BIOMETRIA: "Beneficiário dispensado de Biometria",
        PROCEDIMENTOS_OUTRO_SOLICITANTE: "O beneficiário tem procedimentos de outro solicitante?",
        LABEL_NUMERO_CARTEIRA_SAUDE: 'Número da Carteira CEMIG Saúde',
        LABEL_CARTAO_NACIONAL_SAUDE: 'Cartão Nacional de Saúde',
        LABEL_DADOS_PROFISSIONAL_SOLICITANTE: 'Dados do Profissional Solicitante',
        LABEL_SIM: 'SIM',
        LABEL_RECEM_NASCIDO: "Recém-nascido",
        MENSAGEM_CARTAO_NAO_INFORMADO: "Cartão não informado",
    },
    TELA_SELECIONAR_ATENDIMENTO: {
        TITULO_ACCORDION_CONSULTA_PS: "Consulta em Pronto-Socorro",
        TITULO_ACCORDION_CONSULTA_ELETIVA: "Consulta Eletiva",
        TITULO_ACCORDION_EXAMES_PS: "Exames/Procedimentos em Pronto-Socorro",
        TITULO_ACCORDION_EXAMES_ELETIVOS: "Exames/Procedimentos Eletivos",
        LABEL_ACIMA_BOTOES_ATENDIMENTO: "Selecione abaixo o tipo de atendimento que deseja realizar",
    },
    TELA_CONSULTA_PRONTO_SOCORRO: {
        TITULO_PAGINA: "Consulta em Pronto-Socorro",
        MENSAGEM_LOADER_BUSCANDO_PRESTADOR: 'Obtendo dados do prestador...',
        MENSAGEM_DATA_INVALIDA: "Data inválida!",
        MENSAGEM_SENHA_COPIADA: "Número da senha copiada!",
        MENSAGEM_GUIA_COPIADA: "Número da guia copiada!",
        MENSAGEM_CAMPO_OBRIGATORIO: "Obrigatório",
        MENSAGEM_ATENDIMENTO_AUTORIZADO: " ATENDIMENTO AUTORIZADO",
        MENSAGEM_ATENDIMENTO_NAO_AUTORIZADO: "ATENDIMENTO NÃO AUTORIZADO",
        MENSAGEM_ERRO_GENERICO_AUTORIZACAO:  "Ocorreu um erro, favor contatar a Cemig Saúde.",
        MENSAGEM_INFORMATIVO_IMPRIMIR_GUIA_PS: "A impressão da guia não é uma exigência da CEMIG Saúde.",
        LABEL_NOVO_ATENDIMENTO: "NOVO ATENDIMENTO",
        LABEL_DATA_ATENDIMENTO: "Data de Atendimento",
        LABEL_NUMERO_CARTEIRA: "Nº da Carteira",
        LABEL_RECEM_NASCIDO: 'É recém-nascido',
        LABEL_AUTORIZAR: "AUTORIZAR",
        LABEL_SENHA: 'Senha',
        LABEL_GUIA: 'Número da Guia',
        LABEL_COPIAR: 'COPIAR',
        NOTIFICACAO_MENSAGEM_COPIADA: "Mensagem copiada!",
        NOTIFICACAO_DATA_MENOR: 'Data selecionada deve ser menor ou igual a data de hoje',
        NOTIFICACAO_ERRO_COMUNICACAO_SERVICO: "Erro de comunicação com o serviço!",
    },
    TELA_CONSULTA_ELETIVA: {
        TITULO_ACCORDION_DADOS_BENEFICIARIO: "Dados do Beneficiário",
        TITULO_ACCORDION_DADOS_GUIA_CONSULTA: "Dados da Guia de Consulta",
        TITULO_TELA_CONSULTA_ELETIVA: "Consulta Eletiva",
        MENSAGEM_LOADER_BUSCANDO_PRESTADOR: 'Obtendo dados do prestador...',
        MENSAGEM_ATENDIMENTO_CONLUIDO: "Atendimento concluido com sucesso",
        MENSAGEM_ATENDIMENTO_AUTORIZADO: "ATENDIMENTO AUTORIZADO",
        MENSAGEM_ANTECIPAR_COBRANCA: "ANTECIPAR DIGITAÇÃO DA GUIA DE COBRANÇA",
        MENSAGEM_NENHUM_PROFISSIONAL_ENCONTRADO: 'Nenhum profissional encontrado',
        MENSAGEM_NENHUMA_OCUPACAO_ENCONTRADA: 'Nenhuma ocupação encontrada',
        MENSAGEM_NENHUMA_INDICACAO_ENCONTRADA: 'Nenhuma indicação encontrada',
        MENSAGEM_NENHUM_TIPO_CONSULTA_ENCONTRADO: 'Nenhum tipo consulta encontrado',
        MENSAGEM_BENEFICIARIO_NAO_ELEGIVEL: "BENEFICIÁRIO NÃO ELEGÍVEL",
        MENSAGEM_CAMPO_OBRIGATORIO: 'Obrigatório',
        MENSAGEM_INDICACAO_CLINICA_MINIMO_CARACTER: "A indicação clínica precisa ter no mínimo {caracter} caracteres para continuar",
        MENSAGEM_INDICACAO_CLINICA_TEXTO_INVALIDO: "O texto \"{textoProibido}\" não é válido para indicação clínica",
        MENSAGEM_DATA_INVALIDA: 'Data selecionada inválida',
        MENSAGEM_CONTATE_CEMIG_SAUDE: 'Por favor, contate a CEMIG Saúde.',
        LABEL_GRAVAR_GUIA: "GRAVAR GUIA",
        LABEL_PROFISSIONAL_EXECUTANTE: "Profissional Executante",
        LABEL_TIPO_CONSULTA: "Tipo de Consulta",
        LABEL_INDICACAO_ACIDENTE: "Indicação de Acidente",
        LABEL_OCUPACAO: "Ocupação",
        LABEL_DATA_ATENDIMENTO: "Data de Atendimento",
        LABEL_NUMERO_CARTEIRA: "Nº da Carteira",
        LABEL_RECEM_NASCIDO: 'É recém-nascido',
        LABEL_VERIFICAR: "VERIFICAR",
        LABEL_AUTORIZAR: "AUTORIZAR",
        LABEL_IMPRIMIR_GUIA: "IMPRIMIR GUIA DE CONSULTA",
        LABEL_NOVO_ATENDIMENTO: "NOVO ATENDIMENTO",
        LOADER_AUTORIZAR_CONSULTA: "Autorizando Consulta",
        LOADER_GERAR_GUIA: "Gerando guia",
        NOTIFICACAO_COPIAR_GUIA: "Número da guia copiada!",
        MENSAGEM_API_ERROR: "OCORREU UM PROBLEMA NA OPERAÇÃO",
        MENSAGEM_ERRO_SERVICO_ELEGIBILIDADE: "Erro ao tentar verificar a elegibilidade",
        MENSAGEM_ERRO_SOLICITAR_CONSULTA: "Erro ao solicitar a consulta",
        // MENSAGEM_ERRO_SALVAR_COBRANCA: "Erro ao salvar cobrança",
        MENSAGEM_API_ERROR_SUBTITULO: "TENTE NOVAMENTE OU ENTRE EM CONTATO COM A CEMIG SAÚDE",
        NOTIFICACAO_ERRO_COMUNICACAO_SERVICO: "Erro de comunicação com o serviço!",
        NOTIFICACAO_DATA_MENOR: 'Data selecionada deve ser menor ou igual a data de hoje',
        NOTIFICACAO_SUCESSO_BENEFICIARIO_ATIVO: 'Beneficiário ativo!',
        NOTIFICACAO_SUCESSO_ANTECIPAR_COBRANCA: 'Antecipação de cobrança realizada com sucesso!',
        NOTIFICACAO_ERRO_ANTECIPAR_COBRANCA: 'Ocorreu um problema!',
        NOTIFICACAO_ERRO_IMPRIMIR_GUIA: 'Ocorreu um problema ao imprimir a guia',
        NOTIFICACAO_ERRO_LISTAR_PROFISSIONAIS: 'Ocorreu um problema ao listar os profissionais executantes',
    },
    TELA_EXAMES_PROCEDIMENTOS: {
        TITULO_TELA_EXAMES_PROCEDIMENTOS_PS: "Exames/Procedimentos em Pronto-Socorro",
        TITULO_TELA_EXAMES_PROCEDIMENTOS_ELETIVOS: "Exames/Procedimentos Eletivos",
        TITULO_ACCORDION_DADOS_BENEFICIARIO: "Dados do Beneficiário",
        TITULO_ACCORDION_DADOS_SOLICITACAO: "Dados da Solicitação",
        TITULO_ACCORDION_DADOS_PROCEDIMENTOS: "Procedimentos e Exames Solicitados",
        TITULO_MODAL_INDICACAO_CLINICA: "Indicação Clínica",
        TITULO_MODAL_PROCEDIMENTO_NEGADO: 'Procedimento negado',
        MENSAGEM_DATA_INVALIDA: "Data inválida!",
        MENSAGEM_LOADER_BUSCANDO_PRESTADOR: 'Obtendo dados do prestador...',
        MENSAGEM_CAMPO_OBRIGATORIO: "Obrigatório",
        MENSAGEM_INDICACAO_CLINICA_MINIMO_CARACTER: "A indicação clínica precisa ter no mínimo {caracter} caracteres para continuar",
        MENSAGEM_INDICACAO_CLINICA_TEXTO_INVALIDO: "O texto \"{textoProibido}\" não é válido para indicação clínica",
        MENSAGEM_PROFISSIONAL_NAO_ENCONTRADO: "Não encontrei o profissional",
        MENSAGEM_TOOLTIP_REQUER_AUDITORIA_ANTES_AUTORIZAR: "Será necessário informar a indicação clinica deste procedimento para enviar para auditoria",
        MENSAGEM_TOOLTIP_REQUER_AUDITORIA_DEPOIS_AUTORIZAR: "Este procedimento requer auditoria",
        MENSAGEM_BENEFICIARIO_NAO_ELEGIVEL: "BENEFICIÁRIO NÃO ELEGÍVEL",
        MENSAGEM_ATENDIMENTO_EM_ANALISE: "ATENDIMENTO EM ANÁLISE",
        MENSAGEM_ATENDIMENTO_AUTORIZADO: "ATENDIMENTO AUTORIZADO",
        MENSAGEM_ATENDIMENTO_PARCIALMENTE_AUTORIZADO: "ATENDIMENTO PARCIALMENTE AUTORIZADO",
        MENSAGEM_ATENDIMENTO_NAO_AUTORIZADO: "ATENDIMENTO NÃO AUTORIZADO",
        MENSAGEM_API_ERROR: "OCORREU UM PROBLEMA NA OPERAÇÃO",
        MENSAGEM_API_ERROR_SUBTITULO: "TENTE NOVAMENTE OU ENTRE EM CONTATO COM A CEMIG SAÚDE",
        MENSAGEM_NENHUM_CONSELHO_ENCONTRADO: 'Nenhum conselho encontrado',
        MENSAGEM_NENHUM_ESTADO_ENCONTRADO: 'Nenhum estado encontrado',
        MENSAGEM_NENHUM_PROCEDIMENTO_ENCONTRADO: 'Nenhum procedimento encontrado',
        MENSAGEM_NENHUMA_OCUPACAO_ENCONTRADA: 'Nenhuma ocupação encontrada',
        MENSAGEM_INFORME_INDICACAO_CLINICA: "Informe a indicação clínica:",
        MENSAGEM_INFORME_INDICACAO_CLINICAOBRIGATORIO: "Informe a indicação clínica para auditoria:",
        MENSAGEM_AJAX_LOADER_GUIA: 'Aguarde, fazendo o download da guia',
        MENSAGEM_ACOMPANHAR_SOLICITACAO: 'Você deverá acompanhar a solicitação pelo portal do prestador',
        LABEL_DATA_ATENDIMENTO: "Data de Atendimento",
        LABEL_NUMERO_CARTEIRA: "Nº da Carteira",
        LABEL_RECEM_NASCIDO: 'É recém-nascido',
        LABEL_MOSTRAR_DETALHES: "VER DETALHES",
        LABEL_NOME_PROFISSIONAL: "Nome do Profissional",
        LABEL_SENHA: "Senha",
        LABEL_AVANCAR: "AVANÇAR",
        LABEL_GUIA: "Número da Guia",
        LABEL_NUMERO_CONSELHO: "Número do conselho",
        LABEL_ESTADO: "Estado",
        LABEL_CONSELHO: "Conselho",
        LABEL_COPIAR: "COPIAR",
        LABEL_NOVO_ATENDIMENTO: "NOVO ATENDIMENTO",
        LABEL_PROCEDIMENTO: "Procedimento",
        LABEL_IMPRIMIR_GUIA: "IMPRIMIR GUIA",
        LABEL_QUANTIDADE: "Qtd.",
        LABEL_QUANTIDADE_SOLICITADA: "Qtd. solicitada",
        LABEL_QUANTIDADE_AUTORIZADA: "Qtd. autorizada",
        LABEL_INCLUIR: "INCLUIR",
        LABEL_TABLE_PROCEDIMENTO: "Procedimento",
        LABEL_TABLE_QUANTIDADE: "Quantidade",
        LABEL_TABLE_REQUER_AUDITORIA: "Passível de Auditoria",
        LABEL_TABLE_AUDITORIA: "Auditoria",
        LABEL_TABLE_SITUACAO: "Situação",
        LABEL_TABLE_MOTIVO: "Motivo",
        LABEL_OCUPACAO: "Ocupação",
        LABEL_TABLE_EXCLUIR: "Excluir",
        LABEL_AUTORIZAR: "AUTORIZAR",
        LABEL_VERIFICAR: "VERIFICAR",
        LABEL_JUSTIFICATIVA: "Justificativa",
        LABEL_PROFISSIONAL_SOLICITANTE: "Profissional Solicitante",
        LABEL_CONTINUAR_INDICACAO_CLINICA: "CONTINUAR",
        PLACEHOLDER_PROFISSIONAL_SOLICITANTE: 'Digite o nome ou número do conselho do profissional',
        PLACEHOLDER_PROCEDIMENTO: 'Digite o código ou descrição do procedimento',
        STATUS_AUTORIZADO: "autorizado",
        STATUS_NEGADO: "negado",
        STATUS_EM_ANALISE: "em análise",
        NOTIFICACAO_DATA_MENOR: 'Data selecionada deve ser menor ou igual a data de hoje',
        NOTIFICACAO_INSERIR_NA_TABELA: "Inserido na tabela com sucesso!",
        NOTIFICACAO_INSERIR_REPETIDO: "Procedimento já foi inserido na tabela!",
        NOTIFICACAO_COPIAR_SENHA: "Número da senha copiada!",
        NOTIFICACAO_COPIAR_GUIA: "Número da guia copiada!",
        NOTIFICACAO_ERRO_IMPRESSAO : 'Ocorreu um problema ao imprimir a guia',
        NOTIFICACAO_SUCESSO_BENEFICIARIO_ATIVO: "Beneficiário ativo!",
        NOTIFICACAO_ERRO_DADOS_BENEFICIARIO: "Algum dado na seção beneficiário não foi informado",
        NOTIFICACAO_ERRO_DADOS_SOLICITACAO : "Algum dado na seção solicitação não foi informado",
        NOTIFICACAO_ERRO_DADOS_PROCEDIMENTOS: "Algum dado na seção procedimentos não foi informado",
        NOTIFICACAO_ERRO_COMUNICACAO_SERVICO: "Erro de comunicação com o serviço!",
    },
    MODAL: {
        NOTIFICACAO_COPIAR_JUSTIFICATIVA: "Justificativa copiada!",
    },
    TELA_GERACAO_LOTE_COBRANCA: {
        TITULO_PAGINA: "Envio de Lotes de Cobrança",
        TITULO_ACCORDION: "Buscar e filtrar resultados",
        TITULO_MODAL_LOTE_SUCESSO: 'Lote enviado com sucesso',
        TITULO_MODAL_LOTE_FALHA: 'Lote não enviado',
        TITULO_MODAL_REMOVER_COBRANCA: 'Apagar cobrança',
        MENSAGEM_MODAL_REMOVER_COBRANCA: 'Deseja realmente apagar esta cobrança? Esta ação é irreversível!',
        MENSAGEM_CAMPO_OBRIGATORIO: 'Obrigatório',
        MENSAGEM_DATA_INVALIDA: 'Data inválida!',
        MENSAGEM_ERROR_EXCLUIR_COBRANCA: 'Desculpe, ocorreu um erro ao tentar excluir a cobrança!',
        MENSAGEM_SUCESSO_EXCLUIR_COBRANCA: 'Cobranca excluída com sucesso!',
        MENSAGEM_LOADER_BUSCANDO_PRESTADOR: 'Obtendo dados do prestador...',
        TEXTO_ACIMA_ACCORDION: "Abaixo estão as cobranças geradas por você. Selecione as cobranças que você quer incluir no lote de cobrança.",
        NOTIFICACAO_DATA_INVALIDA: 'Data selecionada deve ser menor ou igual a data de hoje',
        NOTIFICACAO_DATA_INICIAL_MAIOR_DATA_FINAL: 'Data inicial deve ser igual ou menor que data final',
        NOTIFICACAO_SUCESSO_RETORNO_VAZIO: "Não foi encontrado nenhuma cobrança",
        NOTIFICACAO_ERRO_SERVIDOR: "Ocorreu um problema ao obter a listagem de cobranças",
        NOTIFICACAO_PROTOCOLO_COPIADO: 'Número de protocolo copiado!',
        NOTIFICACAO_CODIGO_GLOSA_COPIADO: 'Código de erro copiado!',
        LABEL_BUSCAR_POR: "Buscar por:",
        LABEL_GUIAS_SELECIONADAS: 'cobrança(s) selecionada(s)',
        LABEL_ENVIAR_LOTE: 'ENVIAR LOTE',
        LABEL_TIPO_GUIA: "Tipo de atendimento",
        LABEL_TABLE_APAGAR: 'Apagar',
        LABEL_FILTRAR_PERIODO_DE_TEMPO: "Filtrar por período de tempo",
        LABEL_FILTRAR: "FILTRAR",
        LABEL_NUM_PROTOCOLO_MODAL: 'Nº do protocolo',
        LABEL_NUM_LOTE_MODAL: 'Nº do lote',
        LABEL_DATA_MODAL: 'Data',
        LABEL_VALOR_MODAL: 'Valor',
        LABEL_COD_ERRO_MODAL: 'Cód. de erro',
        LABEL_DESCRICAO_MODAL: 'Descrição',
        LABEL_COPIAR: 'COPIAR',
        LABEL_TABLE_NUMERO_GUIA: 'Número da guia',
        LABEL_TABLE_NUMERO_CARTEIRA: 'Número da carteira',
        LABEL_TABLE_BENEFICIARIO: 'Beneficiário',
        LABEL_TABLE_DATA_ATENDIMENTO: 'Data de atendimento',
        LABEL_TABLE_TIPO_ATENDIMENTO: 'Tipo de atendimento',
        LABEL_IMPRIMIR: 'IMPRIMIR',
        TITULO_CHECKBOX_SELECIONAR_TODOS: 'Selecionar todos'
    },
    TELA_REIMPRESSAO_GUIA: {
        TITULO_PAGINA: "Reimpressão de Guias",
        TITULO_ACCORDION: "Buscar e filtrar resultados",
        TEXTO_ACIMA_ACCORDION: "Abaixo estão as autorizações solicitadas. Selecione uma para fazer a reimpressão da guia.",
        LABEL_FILTRAR: 'FILTRAR',
        LABEL_DE: 'de',
        LABEL_A: 'a',
        LABEL_NUMERO_GUIA: 'Número da guia',
        LABEL_NUMERO_CARTEIRA: 'Número da carteira',
        LABEL_BUSCAR_POR: 'Buscar por:',
        LABEL_TIPO_GUIA: 'Tipo de guia',
        LABEL_OBRIGATORIO: 'Obrigatorio!',
        LABEL_BENEFICIARIO: 'Beneficiário',
        LABEL_REIMPRIMIR_GUIA: 'Reimprimir guia',
        LABEL_DATA_ATENDIMENTO: 'Data de atendimento',
        LABEL_TIPO_ATENDIMENTO: 'Tipo de atendimento',
        LABEL_NOME_BENEFICIARIO: 'Nome do beneficiário',
        LABEL_NOME_PROFISSIONAL_SOLICITANTE: 'Nome do profissional solicitante',
        LABEL_TIPO_ATENDIMENTO_TABELA_CONSULTA_ELETIVA: 'Consulta eletiva',
        LABEL_TIPO_ATENDIMENTO_TABELA_EXAMES_PROCEDIMENTOS_ELETIVOS: 'Exames Eletivos',
        LABEL_TIPO_ATENDIMENTO_TABELA_CONSULTA_PS: 'Consulta em Pronto Socorro',
        LABEL_TIPO_ATENDIMENTO_TABELA_EXAMES_PROCEDIMENTOS_PS: 'Exames Pronto Socorro',
        LABEL_FILTRAR_POR_PERIODO_TEMPO: 'Filtrar por período de tempo',
        NOTIFICACAO_SUCESSO_RETORNO_VAZIO: "Não foi encontrada nenhuma guia",
        NOTIFICACAO_ERRO_IMPRESSAO : 'Ocorreu um problema ao imprimir a guia',
        NOTIFICACAO_ERRO_SERVIDOR: "Ocorreu um problema ao obter a listagem de guias",
        NOTIFICACAO_DATA_INVALIDA: 'Data selecionada deve ser menor ou igual a data de hoje',
        NOTIFICACAO_DATA_INICIAL_MAIOR_DATA_FINAL: 'Data inicial deve ser igual ou menor que data final',
        NOTIFICACAO_ERRO_IMPRIMIR_GUIA: 'Ocorreu um problema ao imprimir a guia',
        NOTIFICACAO_DATA_MENOR: 'Data selecionada deve ser menor ou igual a data de hoje',
        MENSAGEM_LOADER_BUSCANDO_PRESTADOR: 'Obtendo dados do prestador...',
        MENSAGEM_AJAX_LOADER: 'Aguarde, fazendo o download da guia',
    },
    TELA_PROFISSIONAIS_EXECUTANTES: {
        TITULO_PAGINA: "Profissionais Executantes",
        TITULO_CADASTRAR_PROFISSIONAL: 'Cadastrar profissional executante',
        TITULO_EDITAR_PROFISSIONAL: 'Editar',
        LABEL_TABLE_NOME_PROFISSIONAL: 'Nome do profissional',
        LABEL_TABLE_NUMERO_CONSELHO: 'Número do conselho',
        LABEL_TABLE_CONSELHO: 'Conselho',
        LABEL_TABLE_ESTADO: 'Estado',
        LABEL_TABLE_OCUPACAO: 'Ocupação',
        LABEL_TABLE_EDITAR: 'Editar',
        LABEL_TABLE_APAGAR: 'Apagar',
        LABEL_BUSCAR_POR: 'Buscar por:',
        LABEL_NOME_PROFISSIONAL_SOLICITANTE: 'Nome',
        LABEL_OCUPACAO: 'Ocupação',
        LABEL_CADASTRAR: 'CADASTRAR',
        LABEL_EDITAR: 'EDITAR',
        LABEL_CONSELHO: 'Conselho',
        LABEL_OBRIGATORIO: 'Obrigatório',
        LABEL_NUMERO_CONSELHO: 'Número do conselho',
        LABEL_ESTADO: 'Estado',
        LABEL_CADASTRAR_NOVO: 'CADASTRAR NOVO',
        LABEL_FILTRAR: 'FILTRAR',
        MODAL_LABEL_SIM: 'Sim',
        MODAL_LABEL_NAO: 'Não',
        MODAL_TITULO_REMOVER_PROFISSIONAL: 'Remover profissional executante',
        MODAL_MENSAGEM_REMOVER_PROFISSIONAL: 'Tem certeza que deseja remover o profissional? Esta ação é irreversível!',
        MENSAGEM_NENHUMA_OCUPACAO_ENCONTRADA: 'Nenhuma ocupação encontrada',
        MENSAGEM_LOADER_BUSCANDO_PRESTADOR: 'Obtendo dados do prestador...',
        MENSAGEM_NENHUM_CONSELHO_ENCONTRADO: 'Nenhum conselho encontrado',
        MENSAGEM_NENHUM_ESTADO_ENCONTRADO: 'Nenhum estado encontrado',
        NOTIFICACAO_SUCESSO_RETORNO_VAZIO: "Não foi encontrado nenhum profissional executante!",
        NOTIFICACAO_ERRO_SERVIDOR: "Ocorreu um problema ao obter a listagem de guias",
        NOTIFICACAO_ERRO_CADASTRAR: 'Ocorreu um problema ao cadastrar o profissional',
        NOTIFICACAO_ERRO_EDITAR: 'Ocorreu um problema ao editar o profissional',
        NOTIFICACAO_PROFISSIONAL_JA_CADASTRADO: 'Profissional já cadastrado!',
        NOTIFICACAO_PROFISSIONAL_CADASTRADO_SUCESSO: 'Profissional cadastrado com sucesso!',
        NOTIFICACAO_PROFISSIONAL_EDITADO_SUCESSO: 'Profissional editado com sucesso!',
    },
    TELA_INCLUSAO_PROFISSIONAL: {
        HEADER_INCLUSAO_PROFISIONAL_SAUDE: 'Inclusão de Profissional de Saúde',
        LABEL_DIGITE_NOME: 'Digite o nome',
        LABEL_DIGITE_CR: 'Digite o C.R.',
        LABEL_SELECIONTE_CR: 'Selecione um C.R.',
        LABEL_SELECIONE_ESTADO: 'Selecione o Estado',
        LABEL_CRIAR_NOVO_PROFISSIONAL: 'Criar novo profissional',
        BUTTON_FECHAR: 'Fechar',
        BUTTON_SALVAR: 'Salvar',
        NOTIFICACAO_PROFISSIONAL_SALVO_SUCESSO: 'Salvo com sucesso!',
        NOTIFICACAO_PROFISSIONAL_ERRO_SALVAR: 'Erro ao salvar',
        NOTIFICACAO_PROFISSIONAL_SALVANDO_AGUARDE: 'Salvando, aguarde...',
    },
    GERAL: {
        TITULO_APLICACAO: 'Autorizador',
        MENSAGEM_LOADER_VERIFICANDO:  "Verificando",  
        LABEL_USUARIO_GENERICO: 'Usuário', 
        LABEL_DESLOGAR: 'Logout',
        LABEL_PROFILE: 'Profile',
        LABEL_MENU: 'Menu',
        LABEL_MENU_PROFISSIONAIS_EXECUTANTES: 'Profissionais Executantes',
        LABEL_MENU_GERACAO_LOTE_COBRANCA: 'Envio de lotes de cobrança de consulta eletiva',
        LABEL_MENU_REIMPRESSAO_GUIAS: 'Reimpressão de guias',
        MODAL_LABEL_SIM: 'Ir para tela principal',
        MODAL_LABEL_TROCAR: 'Ir',
        MODAL_LABEL_NAO: 'Cancelar',
        MODAL_TITULO_VOLTAR_TELA_HOME: 'Retornar para a seleção de atendimento',
        MODAL_TITULO_TROCAR_DE_TELA: 'Mudança de tela',
        MODAL_MESANGEM_TROCAR_DE_TELA: 'Tem certeza que deseja mudar de tela? Os dados preenchidos nesta tela serão todos perdidos!',
        MODAL_MENSAGEM_VOLTAR_TELA_HOME: 'Tem certeza que deseja retornar para a tela de seleção de atendimento? Os dados preenchidos nesta tela serão todos perdidos!',
    }
}

export default mensagens;